import Vue from "vue";
let baseURL = {}
var domain = window.location.host
var host = domain.substring(domain.indexOf('.')+1);//截取第一个点的位置来获取根域名,这样只能获取二级域名的根域名，如果直接是不带www的域名访问，那么就会直接获取域名的后缀
if(host.indexOf('.') == -1){
    host = window.location.host
}
host = "blackrocknovel.com"
if (process.env.NODE_ENV === "test" || process.env.NODE_ENV === "development") {
    // 开发环境 || 测试
    baseURL.novelapi = 'http://test-biz.'+host
} else if (process.env.VUE_APP_TITLE === "prod") {
    // 生产
    baseURL.novelapi = 'https://biz.'+host
    Vue.prototype.isShowA = false;
}

export default baseURL
